import { atom } from "recoil";

export const addStateChannel = atom({
  key: "addStateChannel",
  default: false,
});
export const editStateChannel = atom({
  key: "editStateChannel",
  default: false,
});
export const rowEditIdStateChannel = atom({
  key: "rowEditIdStateChannel",
  default: null,
});
export const disableButtonStateChannel = atom({
  key: "disableButtonStateChannel",
  default: false,
});

export const selectedRowsStateChannel = atom({
  key: "selectedRowsStateChannel",
  default: [],
});

export const setFilterTextChannel = atom({
  key: "setFilterTextChannel",
  default: "",
});
